module.exports = "<action-list-item ng-if=restrictUi.asPrivateBetaFeature() contents=\"{\n    iconClass: 'fa-book',\n    ordinal: $ctrl.contents.ordinal,\n    title: 'Ledgers',\n    description: 'Browse your historic and current ledgers',\n    state: $state.current.data.workflowBaseState + '.ledgers-overview',\n    actions: [],\n}\"></action-list-item> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/components/action-list-items/contents/ledgers.html
// module id = 1739
// module chunks = 86